import React from 'react';
import { Column, ColumnContent, IColumnProps } from './Column';
import { withTranslate } from '../../../../../shared/i18n/translate';
import { ColumnHeader } from '../../../../overview/ui/list/item/Column';

interface IGateColumnProps extends IColumnProps {
	gate: string;
}

export const GateColumn = withTranslate<IGateColumnProps>(
	({ t, gate, columns }) => (
		<Column columns={columns}>
			<ColumnHeader>{t('flight_details_gate')}</ColumnHeader>
			<ColumnContent>{gate}</ColumnContent>
		</Column>
	),
);
